<template>
  <div class="w-100">
    <div class="col-md-12 pr-1 pl-0">
      <div v-for="(img , ind) in images" :key="img.pdphotoid" class="edit-photospage  mr-4 pb-2" :id="`edit-photospage${ind + 3}`">
        <div class="innerdoc template3 mt-1 mr-2 pb-0" :style="{height: divHeight}">
          <div class="header col-md-12" style="height: 10%">
            <div class="row">
              <div class="col-md-6">
                <img :src="logo_one" class="mb-2 img-fluid logo-images-in-docs" alt="img">
              </div>
              <div class="col-md-6 text-right">
                <img :src="logo_two" class="mb-2 img-fluid logo-images-in-docs" alt="img">
              </div>
            </div>
          </div>
          <div class="body pb-3 pb-xl-4 position-relative" style="height: 90%">
            <div class="row h-100">
              <div class="col-md-12" style="max-height: 60%">
                <div class="pb-2 h-100">
                  <img :src="`${photoUrl}&projectid=${images[ind].projectid}&id=${images[ind].pdphotoid}`" class="img-fluid" alt="image">
                </div>
              </div>
              <div class="col-md-12 pr-4" style="height: 31%">
                <div class="mb-1">
                  <p>
                    Foto-Nr  : {{images[ind].runid}}
                  </p>
                  <p>
                    Aufnahmedatum : {{ images[ind].photodate | date }}
                  </p>
                  <p>
                    Dateiname: {{images[ind].origname}}
                  </p>
                  <p> Planzuordnung: Nur im PDF sichtbar </p>
                </div>
                <div class="mb-1">
                  <p v-for="tag in images[ind].params" :key="tag.projectparamid">
                    {{tag.group}}<strong>:</strong>  {{tag.name}}
                  </p>
                </div>
                <div class="pr-2">
                  <textarea class="form-control" rows="5" v-model="images[ind].pdphototext" :disabled="selectedDocument.reporttype === '0'" placeholder="Fotobeschreibung hinzufügen"></textarea>
                </div>
              </div>
            </div>


            <div class="row mt-2" v-if="images.length === 0">
              <div class="col-md-12 text-center">
                <h4> Fotobeschreibung hinzufügen </h4>
              </div>
            </div>
            <div v-if="images.length > 0" class="stickynav">
              <sliding-pagination
                :current="currentPage"
                :total="images.length + 2"
                @page-change="pageChangeHandler"/>
            </div>
            <p class="text-center border-top position-absolute foot">
              Seite {{ ind  + 3  }}  von {{ images.length + 2 }}
              <span class="float-right">projectdocu.com</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SlidingPagination from 'vue-sliding-pagination'
import {formatDate} from '../../../common'
export default {
  props: ['logo_one','logo_two'],
  data () {
    return {
      is_loading: true,
      currentPage: 1,
      index: 0,
      divHeight: "1000px",
      page: 1
    }
  },
  components: {
    SlidingPagination
  },

  mounted () {
    this.changeActivePageOnScroll();
    let width = document.querySelector('.innerdoc').offsetWidth
    this.divHeight = `${width * 1.4}px`
  },
  filters: {
    date: (d) => formatDate(d,true)
  },
  computed: {
    photoUrl: () => `${process.env.VUE_APP_GET_METHOD_URL}img&token=${localStorage.sessiontoken}&type=l`,

    images () {
      if (this.selectedDocument.reporttype == '0'){
        return this.$store.getters.getDailyReportPhotos
      }else {
        return this.$store.getters.getSpecialReportPhotos
      }
    },
    theme () {
      return this.$store.state.photoDocumentation.selectedTemplate
    },
    selectedDocument(){
      if (this.$route.name === "photoDocumentEdit"){
        return this.$store.state.photoDocumentation.selectedDocument
      }else {
        return  this.$store.state.photoDocumentation.newDocumentDetails
      }
    },
    pageImages () {
      let _this = this
      return this.images.slice(_this.index, _this.index + 2)
    }
  },
  methods: {
    // get image for Slider
    pageChangeHandler (selectedPage) {
      if (selectedPage === 1){
        // Scroll to cover page
        this.currentPage = selectedPage
        document.getElementById("edit-coverpage").scrollIntoView({ behavior: "smooth" });
      }else if (selectedPage === 2){
        //Scroll to the text page
        this.currentPage = selectedPage
        document.getElementById("edit-textpage").scrollIntoView({ behavior: "smooth" });
      }else {
        //Scroll to the Photo page
        document.getElementById(`edit-photospage${selectedPage}`).scrollIntoView({ behavior: "smooth" });
        this.currentPage = selectedPage
        this.page = selectedPage
        this.index = ((selectedPage - 3) * 2);
      }
    },

    /**
     * Change active page when user scroll the pages
     */
    changeActivePageOnScroll(){
      let _this = this
      document.querySelector('.docs-details').onscroll = function (e){
        let  scroll_val = e.target.scrollTop
        let page_height = document.querySelector('.edit-photospage').offsetHeight
        let page = Math.floor((scroll_val / page_height)) + 1
        if (page > _this.currentPage){
          _this.currentPage = page
        }else if(page < _this.currentPage){
          _this.currentPage = page
        }
      }
    }
  }
}
</script>
<style scoped>
p{
  padding-bottom: 4px;
}
img{
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/PhotoDetails/OnePhotoDetails.vue